
  import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue';
  import { AMETIST_URL, AMETIST_HOME, promotionSessionId, trackPromotion } from '@/services/analytics';

  export default defineComponent({
    name: 'AmetistPromotion',
    setup() {
      const banner = ref<HTMLElement | null>(null);
      let observer: IntersectionObserver;
      let timer: number | undefined;
      let retry: number;
      let visible = false;
      let recordedSession: string | null = null;
      let inFlight = false;
      const cancel = () => {
        window.clearTimeout(timer);
        timer = undefined;
      };
      const checkVisibility = () => {
        cancel();
        const visit = promotionSessionId();
        if (!visible || !visit || recordedSession === visit || inFlight) return;
        timer = window.setTimeout(async () => {
          if (!visible || document.visibilityState !== 'visible' || promotionSessionId() !== visit) return;
          inFlight = true;
          if (await trackPromotion('impression')) recordedSession = visit;
          inFlight = false;
        }, 1000);
      };
      const trackClick = () => {
        void trackPromotion('click');
      };
      const trackAuxClick = (event: MouseEvent) => {
        if (event.button === 1) trackClick();
      };
      onMounted(() => {
        observer = new IntersectionObserver(
          ([entry]) => {
            visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            checkVisibility();
          },
          { threshold: [0, 0.5, 1] }
        );
        if (banner.value) observer.observe(banner.value);
        document.addEventListener('visibilitychange', checkVisibility);
        retry = window.setInterval(checkVisibility, 15000);
      });
      onBeforeUnmount(() => {
        observer?.disconnect();
        cancel();
        window.clearInterval(retry);
        document.removeEventListener('visibilitychange', checkVisibility);
      });
      return { banner, landingUrl: AMETIST_URL, homeUrl: AMETIST_HOME, trackClick, trackAuxClick };
    },
  });
